/* eslint-env browser, es6 */
import m from "mithril";

import {
  GameDuelChallenge1View,
  GameDuelChallenge2View,
} from "./game-duel-challenge";
import { GameDuelResultsView } from "./game-duel-results";
import { GameFinishedView } from "./game-finished";
import { GameInProgressView } from "./game-in-progress";
import { GameLoadingView } from "./game-loading";
import { GameNotStartedView } from "./game-not-started";
import { GAME, GameStateMarker } from "../game-state";

export class GameView implements m.Component {
  view(): m.Children {
    switch (GAME.state.marker) {
      case GameStateMarker.Loading:
        return m(GameLoadingView);
      case GameStateMarker.NotStarted:
        return m(GameNotStartedView, { state: GAME.state });
      case GameStateMarker.InProgress:
        return m(GameInProgressView, { state: GAME.state });
      case GameStateMarker.Finished:
        return m(GameFinishedView, { state: GAME.state });
      case GameStateMarker.DuelChallenge1:
        return m(GameDuelChallenge1View, { state: GAME.state });
      case GameStateMarker.DuelChallenge2:
        return m(GameDuelChallenge2View, { state: GAME.state });
      case GameStateMarker.DuelResults:
        return m(GameDuelResultsView, { state: GAME.state });
    }
  }
}
